import React, {Fragment, useContext, useEffect, useRef} from 'react'
import {FormattedMessage} from 'react-intl'
import {ICar} from '../../../../models/Car'
import { IStation } from '../../../../models/Station'
import {ListViewType} from '../../../config/constants'
import Pager from '../../common/Pager'
import {RouterContext} from '../../containers/Context'
import CarPanel from '../../user/cars/CarPanel'
import SingleStation from '../../user/SingleStation'
import styles from './ListView.scss'
import { ListMode } from '../../user/stations/MapListNavbar'
import { useQuery } from '../../hocs/hooks'
import ms from 'ms'
import { dateFromQuery, dateToQuery } from '../../../helpers/dateUtil'
import MapMarkedAlt from '../../../assets/icons/MapMarkedAlt.svg'
import LocaleText from '../../common/LocaleText'

const ListView = (
  {
    mode,
    loading = false,
    listViewType,
    total,
    carOrStationList,
    area,
    prefecture,
    pageSize,
    toggleListMode
  }: {
    mode?: ListMode
    loading?: boolean
    listViewType: ListViewType
    total: number
    carOrStationList: ReadonlyArray<ICar | IStation>
    area?: string
    prefecture?: string
    pageSize: number
    toggleListMode: () => void
  }) => {
  const carPanelRef = useRef()
  const {location} = useContext(RouterContext)!
  const scrollCarId = location?.hash.match('#') && location?.hash.slice(1)
  const query = useQuery()
  let checkInStr = query.checkIn
  let checkOutStr = query.checkOut
  const checkIn = dateFromQuery(checkInStr)
  const checkOut = dateFromQuery(checkOutStr)
  if (checkIn || checkOut) {
    if (!checkIn) checkInStr = dateToQuery(new Date(checkOut!.getTime() - ms('1 days')))
    if (!checkOut) checkOutStr = dateToQuery(new Date(checkIn!.getTime() + ms('1 days')))
  }
  useEffect(() => void (carPanelRef?.current?.scrollIntoView({
    behavior: 'smooth',
    block: 'center',
  })), [location])
  return loading
    ? <div className="loader-wrapper">
        <div className="loader" />
      </div>
    : carOrStationList?.length
      ? <>
        <div className={[
          'position-relative row flex-wrap justify-content-center no-gutters pt-md-20px',
          styles.listTop
        ].join(' ')}>
        {carOrStationList.map(carOrStation => <Fragment key={carOrStation._id}>
          <div className={[mode === ListMode.map ? 'col-12 pl-2' : 'col-md-6 p-2'].join(' ')}
            ref={String(carOrStation._id) === scrollCarId ? carPanelRef : undefined} >
            {listViewType === ListViewType.car
              ? <CarPanel
                  car={carOrStation as ICar}
                  locations={carOrStation.locations}
                  area={area}
                  prefecture={prefecture}
                  viewByList={mode !== ListMode.map}
                  checkIn={checkInStr}
                  checkOut={checkOutStr}
                />
              : <SingleStation
                  station={carOrStation as IStation}
                  isActive={false}
                  viewByList={mode !== ListMode.map}
                  checkIn={checkInStr}
                  checkOut={checkOutStr}
                />
            }
            {mode === ListMode.map && <hr className={['mx-1 my-11px', styles.hr].join(' ')} />}
          </div>
        </Fragment>)}
        {/* onListToggle */}
        <div className={[
          styles.switchMap,
          'position-sticky c-pointer d-flex d-md-none align-items-center justify-content-center font-weight-bold'
        ].join(' ')} onClick={toggleListMode}>
            <MapMarkedAlt className="fa mr-2"/>
            <LocaleText ja="MAP表示" en="Display map" />
        </div>
        </div>
        <div className="d-flex justify-content-center mt-3">
          <Pager
            total={total}
            pageSize={pageSize}
            isVan={listViewType === ListViewType.car}
          />
        </div>
      </>
      : <div className="font-italic py-2 pl-3 pr-4 text-center">
        <FormattedMessage id="home.noResult"/>
      </div>
}
ListView.displayName = 'ListView'
export default ListView
